import {
    createContext,
    Dispatch,
    SetStateAction,
    useContext,
    useState
} from 'react';

interface IAcoesMenu {
    adicionandoTarefa: boolean
}

interface IPropsContext {
    acoesMenu: IAcoesMenu,
    setAcoesMenu: Dispatch<SetStateAction<IAcoesMenu>>,
}

interface IProps {
    children: JSX.Element[] | JSX.Element
}

const AcoesMenuContext = createContext<IPropsContext>({} as IPropsContext);

const AcoesMenuProvider = ({ children }: IProps) => {
    const [acoesMenu, setAcoesMenu] = useState<IAcoesMenu>({ adicionandoTarefa: false });
    return (<AcoesMenuContext.Provider value={{
        acoesMenu,
        setAcoesMenu
    }}>
        {children}
    </AcoesMenuContext.Provider>)
};


export function useAcoesMenu(): [IAcoesMenu, Dispatch<SetStateAction<IAcoesMenu>>] {
    const context = useContext(AcoesMenuContext);
    const { acoesMenu, setAcoesMenu } = context;
    return [acoesMenu, setAcoesMenu];
}

export default AcoesMenuProvider;